var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { parse } from "./parser";
import normalize from "./normalize";
import { bibEntryToRcItem } from "./mapper";
export const asBibItem = ({ text }) => {
    text = normalize(text);
    const parseResult = parse(text);
    return { parseResult, normalizedText: text };
};
export const bibResultAsRcItems = ({ text, bibItemResult, hash }) => __awaiter(void 0, void 0, void 0, function* () {
    const { errors, prettyErrors } = bibItemResult;
    let rcItems = [];
    const { entries } = bibItemResult.bibItem;
    for (const entry of entries) {
        const rcItem = yield bibEntryToRcItem(entry, text, errors, prettyErrors, hash);
        rcItems.push(rcItem);
    }
    rcItems = rcItems.filter(r => r);
    return Object.assign(Object.assign({}, bibItemResult), { rcItems });
});
export const asRcItems = ({ text, hash }) => {
    const { normalizedText, parseResult } = asBibItem({ text });
    return bibResultAsRcItems({ text: normalizedText, bibItemResult: parseResult, hash });
};
